import { provideLottieOptions } from 'ngx-lottie';
import {
  ApplicationConfig,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService } from '@ngx-translate/core';

import { NgRxEffects, NgRxReducer } from '@roi/common/stored/global';
import { LoggingFetchService } from '@roi/common/services/interceptors/logging.interceptor';
import { EventFetchService } from '@roi/common/services/interceptors/event.interceptor';

import { AppRoutes } from './app.routes';

import { Initialize } from './initialize';

import { environment } from '../environments/environment';

import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthConfig } from 'angular-oauth2-oidc';
import player from 'lottie-web';

registerLocaleData(en);

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key]
);

export const AppConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()), // Enable DI-based interceptors
    { provide: HTTP_INTERCEPTORS, useClass: EventFetchService, multi: true },
    ...(environment.production
      ? []
      : [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: LoggingFetchService,
            multi: true,
          },
        ]),

    provideAppInitializer(Initialize),
    provideRouter(AppRoutes),
    provideStore(NgRxReducer),
    provideEffects(NgRxEffects),
    !environment.production
      ? provideStoreDevtools({ maxAge: 32, logOnly: false })
      : [],
    provideTranslateService(),
    provideAnimations(),
    provideNzIcons(icons),
    provideNzI18n(en_US),
    provideOAuthClient(),
    provideLottieOptions({
      player: () => player,
    }),
  ],
};
